
rjm.chartBuilderController = (options) ->
  if not options or not options.clientId or 
      not options.target or not options.chartModel or 
      not options.gaConnections
    throw "InvalidConstructorArgs - Chart Builder Controller"

  @clientId = options.clientId
  @chartId = options.chartId
  @target = options.target
  @isCreate = options.isCreate
  @trendId = options.trendId
  @cohortDefault = options.cohortDefault
  @chartModel = new rjm.model.Chart(options.chartModel)

  # Removing the data from this object, because otherwise we'd be sending it back to the preview
  @chartModel.set data: null

  @chartModel.set dashboardId: options.dashboardId

  @gaConnectionsCollection = new rjm.model.GAConnectionList(options.gaConnections)
  
  @view = new rjm.ui.ChartBuilderContainerView(
    chartModel: @chartModel
    gaConnectionsCollection: @gaConnectionsCollection
    isCreate: @isCreate
    clientId: @clientId
    trendId: @trendId
    cohortDefault: @cohortDefault
  )

  return

rjm.chartBuilderController::start = ->
  @view.setElement(@target).render()
  window.scrollTo(0,0) # Some browsers were keeping their scroll value
  return

rjm.chartBuilderController::destroy = ->
  #Removes the chart model from the store so that we can start fresh the next time we instantiate the chart builder
  Backbone.Relational.store.unregister(@chartModel)
  return
